
import React, { useState, useEffect } from "react";

import { Shop } from '../../components/Shop';
import { ShopForm } from '../../components/ShopForm';
import Modal from '../../components/Modal';
import useModal from '../../helpers/useModal';
import { Loader } from '../../helpers/loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { supabase } from '../../api'
import ELNStore from "../../store";
import { add, sub } from "date-fns";
import BrandForm from "../../components/BrandForm";

export const Shops = () => {

  const currentUser = ELNStore.useState(s => s.currentUser);

  const { showModal, toggleModal } = useModal()
  const { showModal: showBrandModal, toggleModal: toggleBrandModal } = useModal()
  const [shop, setShop] = useState()
  const [brand, setBrand] = useState()

  const [shops, setShops] = useState()
  const [brands, setBrands] = useState()
  const [shopCount, setShopCount] = useState()

  let populated_brand_ids = []


  const handleSelectShop = (shop) => {
    setShop(shop)
    toggleModal()
  }

  const handleSelectBrand = (brand) => {
    setBrand(brand)
    toggleBrandModal()
  }

  useEffect(() => {
    async function fetchData() {

      const today = new Date()
      today.setHours(0, 0, 0, 0)


      const startDate = sub(today, { days: 7 })
      const endDate = add(today, { days: 7, hours: 2 })

      const { data: shops, error: shopsErr } = await supabase
        .from('shops')
        .select('*, brands (*), products (*), orders (delivery_dt)')
        .gte('orders.delivery_dt', startDate.toISOString())
        .lte('orders.delivery_dt', endDate.toISOString())
        .order('name', { foreignTable: 'brands' })
        .order('delivery_dt', { foreignTable: 'orders' })


      if (shopsErr) console.error(shopsErr)

      const { data: brands, error: brandsErr } = await supabase
        .from('brands')
        .select('*')
        .order('name')

      if (brandsErr) console.error(brandsErr)


      setBrands(brands)

      setShopCount(shops.length)
      const sortedShops = shops.sort(function (a, b) { return (`${a.brands.name} ${a.name}` > `${b.brands.name} ${b.name}` ? 1 : -1) })


      const groupedShops = sortedShops.groupBy(s => s.brands.id)
      setShops(groupedShops)

    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal])

  if (!shops) return <Loader />


  const BrandRow = ({ brand }) => {

    return <tr style={{ borderTop: '2px solid black' }}>
      <td colspan='8'><h2 style={{ fontSize: 30, marginTop: 20 }}>{brand.name || <i>no brand name set</i>}</h2>CAN OVERRIDE COST?: {brand.can_override_cost ? <b>YES</b> : 'NO'}<br /><br /></td>
      <td><button className='inv' disabled={currentUser.p_admin < 2} onClick={() => handleSelectBrand(brand)}>Edit</button></td></tr>
  }


  const displayShops = () => {

    if (!shops) return
    return Object.keys(shops).map(brandID => {

      if (!populated_brand_ids.includes(brandID)) {
        populated_brand_ids.push(parseInt(brandID))
      }

      const brand = brands.find(b => b.id === parseInt(brandID))

      return (
        <>
          <BrandRow brand={brand} />
          {shops[brandID].map(s => <Shop readOnly={currentUser.p_admin < 2} handleSelect={handleSelectShop} shop={s || {}} />)}
        </>
      )
    })
  }

  const handleSaveBrand = (brand) => {
    const newBrands = [...brands.filter(c => c.id !== brand.id), brand].sort((a, b) => a.name > b.name ? 1 : -1)
    setBrands(newBrands)
    toggleBrandModal()
  }


  const handleDeleteBrand = (id) => {
    const newBrands = [...brands.filter(c => c.id !== id)].sort((a, b) => a.name > b.name ? 1 : -1)
    setBrands(newBrands)
    toggleBrandModal()
  }



  return (
    <div className='outer'>

      <h1>Shops ({shopCount})</h1>

      {currentUser.p_admin >= 2 && <ul className='button-list'>
        <li><button onClick={() => handleSelectBrand(undefined)}><FontAwesomeIcon icon={faPlus} />&nbsp;ADD NEW BRAND</button></li>
        <li><button onClick={() => handleSelectShop(undefined)}><FontAwesomeIcon icon={faPlus} />&nbsp;ADD NEW SHOP</button></li>
      </ul>}
      <Modal
        isShowing={showModal}
        title={shop?.id ? 'Edit Shop' : 'Add New Shop'}
        hide={toggleModal}
      >

        <ShopForm brands={brands} toggleModal={toggleModal} defaultShop={shop || {}} />

      </Modal>



      <Modal
        isShowing={showBrandModal}
        title={brand?.id ? 'Edit Brand' : 'Add New Brand'}
        hide={toggleBrandModal}
      >

        <BrandForm toggleModal={toggleBrandModal} canDelete={brand && !shops?.[brand.id]} handleSave={handleSaveBrand} handleDelete={handleDeleteBrand} defaultBrand={brand || {}} />

      </Modal>



      <div className='table-wrapper'>
        <table>
          <tr>
            <th>ID</th>
            <th>DISPLAY NAME</th>
            <th>ORDERS PLACED</th>
            <th>LAST ORDER</th>
            <th>NEXT ORDER</th>
            <th>PRODUCTS AVAILABLE</th>
            <th>SHOW IN DELIVERY TABLE?</th>
            <th>CAN CREATE NEW ORDER?</th>
            <th></th>
          </tr>
          {displayShops()}

          {brands.map(b => {
            if (populated_brand_ids.includes(b.id)) return null
            return <BrandRow brand={b} />
          })}
        </table>
      </div>


    </div>
  )
}

export default Shops;